export const postMessageTo = (type, data, target = window.parent) =>
    target.postMessage({ source: "inPoint", type, data }, "*");
